/**
 * Reporting concept (demo tab) — surfaces the standalone "leak-first reporting"
 * HTML concept mock inside the app shell so the client can review it in context.
 *
 * This is a self-contained static artifact served from
 * `public/assets/reporting-leak-concept.html` (byte-faithful to the approved
 * mock, with its own styling, tabs and tooltips). It is embedded via an iframe
 * so nothing here touches app state: the figures are illustrative, not wired to
 * live data. Easy to remove later — delete this file, its route in App.tsx, and
 * its RailLink entry in LeftRail.tsx.
 */
export default function ReportingConcept() {
  return (
    <section className="px-8 py-6" data-testid="reporting-concept">
      <header className="max-w-7xl">
        <p className="label-small-caps text-gold-bright">Concept preview</p>
        <p className="font-serif text-cream-soft mt-2 max-w-3xl">
          Leak-first reporting concept for client review. Illustrative figures &mdash; this preview
          is a design mock and is not wired to live data.
        </p>
      </header>

      <div className="mt-5 max-w-[1400px] rounded-lg overflow-hidden border border-gold-dim/20 bg-ink-black">
        <iframe
          title="Reporting — leak-first concept"
          src="/assets/reporting-leak-concept.html"
          className="w-full block"
          style={{ height: 'calc(100vh - 170px)', border: 0 }}
        />
      </div>
    </section>
  );
}
